import PropTypes from 'prop-types';
import cx from 'classnames';
import Markdown from 'react-markdown';

import withBindProps from 'core/hocs/withBindProps';
import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';
import { replaceSpaces } from 'core/utils/content';

function LineOfContentsItem({ level, children, theme }) {
  if (!children) return null;

  let anchor;
  if (children[0].type === 'a') {
    anchor = children[0]?.props?.children[0];
  }

  const text = children[0];

  const {
    controls: {
      topicContent: {
        tableOfContents: {
          link: {
            hover: linkHoverAtoms,
            ...linkAtoms
          },
        },
      },
    },
  } = theme;

  return (
    <>
      <style jsx>{`
        .item
          margin 12px 0

        .level3
          margin-left 20px
          list-style none

        .link
          text-decoration none
          &:hover
            transition border-color .15s

      `}
      </style>
      <style jsx>{`
        .link
          color ${linkAtoms.color}
          transition color ${theme.animations.hover}
          border-bottom ${linkAtoms.borderBottom}
          &:hover
            color ${linkHoverAtoms.color}
            border-bottom ${linkHoverAtoms.borderBottom}
      `}
      </style>

      <li className={cx('item', level === 3 && 'level3')}>
        <a className='link' href={`#${replaceSpaces(text)}`}>
          {anchor || children}
        </a>
      </li>
    </>
  );
}

LineOfContentsItem.propTypes = {
  level: PropTypes.number,
  theme: PropTypes.object,
};

function LineOfContents(props) {
  const {
    body,
    theme,
  } = props;

  const LineOfContentsItemWithProps = withBindProps({ theme })(LineOfContentsItem);

  /**
   * Стили выносить не нужно, компонент используется в AMP
   */
  return (
    <Markdown
      allowElement={(element, index, parent) =>{
        const headerTags = ['h2', 'h3'];
        const isHeader = headerTags.includes(element.tagName);
        const isHeaderChild = headerTags.includes(parent.tagName);

        return isHeader || isHeaderChild;
      }}
      components={{
        h2: LineOfContentsItemWithProps,
        h3: LineOfContentsItemWithProps,
      }}
    >
      {body}
    </Markdown>
  );
}

LineOfContents.propTypes = {
  body: PropTypes.string.isRequired,
  theme: themePropTypes(`{
    colors: {
      active1,
      primary
    },
    animations: {
      hover
    },
  }`),
};

export default withTheme(LineOfContents);
